export { SmartVideo } from './smart-video';
export type { SmartVideoProps, SmartVideoType } from './smart-video';
